import React, { CSSProperties } from 'react';

import { observer } from 'mobx-react-lite';
import { GridHeaderCellDisplay } from './styledComponents';
import FontAwesome from '@vromo/ui/components/FontAwesome';

interface GridHeaderCellProps {
    setSortColumn: (arg: number) => void;
    sortColumn: number;
    columnIndex: number;
    sortDirection: number;
    style: CSSProperties;
}

const GridHeaderCell = observer<GridHeaderCellProps>(function GridHeaderCell({
    setSortColumn,
    sortColumn,
    columnIndex,
    sortDirection,
    children,
    style
}) {
    const onClick = () => {
        setSortColumn(columnIndex);
    };

    const renderSortIcon = () => {
        return sortColumn === columnIndex ? (
            <FontAwesome icon={sortDirection === 1 ? 'sort-up' : 'sort-down'} />
        ) : null;
    };

    return (
        <GridHeaderCellDisplay onClick={onClick} style={style}>
            {renderSortIcon()} {children}
        </GridHeaderCellDisplay>
    );
});

export default GridHeaderCell;
